export const FETCH_SWITCHORGANIZATIONS_REQUEST = 'FETCH_SWITCHORGANIZATIONS_REQUEST';
export const FETCH_SWITCHORGANIZATIONS_SUCCESS = 'FETCH_SWITCHORGANIZATIONS_SUCCESS';
export const FETCH_SWITCHORGANIZATIONS_FAILURE = 'FETCH_SWITCHORGANIZATIONS_FAILURE';

export const fetchSwitchOrganizationsRequest= (orgId) => ({
    type: FETCH_SWITCHORGANIZATIONS_REQUEST,
    payload:orgId,
});
export const fetchSwitchOrganizationsSuccess = (data) => ({
    type: FETCH_SWITCHORGANIZATIONS_SUCCESS,
    payload: data,
}); 
export const fetchSwitchOrganizationsFailure = (error) => ({
    type: FETCH_SWITCHORGANIZATIONS_FAILURE,
    payload: error,
});
